import Modal from '~/components/Modal';
import StartEndDateTime from '~/components/forms/StartEndDateTime.jsx';
import OptionToggle from '~/components/OptionToggle.jsx';
import { useEffect, useState } from 'react';
import * as Toast from '~/lib/Toast';
import useBusinessPostApi from '~/lib/useBusinessPostApi.js';

const CancelEventModal = ({ isOpen, onClose, event, onCancelEvent }) => {
    const [dontTriggerFlows, setDontTriggerFlows] = useState(false);
    const { save: saveCancel, isSaving: isCanceling } = useBusinessPostApi(
        `/calendar/events/${event?.id}/cancel`,
    );

    function doCancel() {
        saveCancel({ dontTriggerFlows }).then(result => {
            onClose();
            Toast.success(
                result?.message || 'Successfully canceled appointment',
            );
            if (onCancelEvent) {
                onCancelEvent();
            }
        });
    }

    useEffect(() => {
        if (!isOpen) {
            setDontTriggerFlows(false);
        }
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} widthClass="sm:max-w-[450px]">
            <h2 className="mb-6">Cancel Event</h2>
            <div className="text-center">
                {event.event_type?.name} with {event.bookable_resource?.name}
            </div>
            <div className="text-center text-gray-500">
                <StartEndDateTime
                    start={event.client_start}
                    end={event.client_end}
                />
            </div>

            <OptionToggle
                value={!dontTriggerFlows}
                onChange={value => setDontTriggerFlows(!value)}
                toggleFirst={true}
                className="my-4"
                title="Send cancellation automations"
            />

            <div className="flex items-center">
                <button
                    type="button"
                    className="btn-pink-pill-lg"
                    onClick={doCancel}
                >
                    {isCanceling ? 'Canceling...' : 'Cancel Appointment'}
                </button>

                <button
                    type="button"
                    className="btn-gray-pill-lg ml-4"
                    onClick={onClose}
                >
                    Go back
                </button>
            </div>
        </Modal>
    );
};

export default CancelEventModal;
